export default __webpack_public_path__ + "static/media/ghost_blue.75840c94.png";